/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  gs,
//  usePagez,
  l,
} from 'lib';
*/
import * as cr from './_cr';
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import { useLdrz } from "./_csLdr";
import * as _hm from './_hf';
import * as _hmDTM from './_hfDTM';
import * as _ht from './_ht';

import * as icm from './icm';

import * as icvBaseS10Rz from './icvBaseS10Rz';

import * as icvI1z___Ti from './icvI1z___Ti';
import * as icvI1zS10To from './icvI1zS10To';
import * as icvI1zS11Co1 from './icvI1zS11Co1';
import * as icvI1zS11Co2 from './icvI1zS11Co2';
import * as icvI1zS11Co3 from './icvI1zS11Co3';

//let $i18r_fst = -1;

const $pagez = {} as _ht.dz;

export const N = () => {

  const _gUserz = gs.useUserz();
  const _gLdrz = useLdrz();

  const _sPz = ls.usePagez({
    ctt: 'e',
    dffz: icm.grtDffz({
      mode: 'e',
      role: 's',
    }),
    steps: [0],
    i18r_fst: -1,
  });

  icm.loadAtTopAsync({
    _31r_fst: _gUserz.crt._31rz?._fst,
    atrAsync: async () => {
      _gLdrz.show();
      await icm.ilzPagezAsync(_gUserz.crt._31rz._fst, $pagez, {
        sttDate: _hmDTM.addMth(_hmDTM.cvtFdm(_hmDTM.getTdy()), 2),
        endDate: _hmDTM.cvtLdm(_hmDTM.addMth(_hmDTM.cvtFdm(_hmDTM.getTdy()), 2)),
      });
      _gLdrz.hide();
      $pagez.bLoad = false;
      _sPz.udtAll();
    },
  });

  return (
    cr.c(icvBaseS10Rz.N, {
      key: -10,
      sPz: _sPz,
      cz: {
        pageName: 
          _sPz.crt.steps[0] == 0 ?
            'エントリー一覧'
          : _sPz.crt.steps[0] == 1 ?
            '部屋・日時の選択'
          : _sPz.crt.steps[0] == 2 ?
            '団体の選択'
          : _sPz.crt.steps[0] == 3 ?
            'エントリー詳細確認・変更・キャンセル・削除'
          : '',
      },
      oClds: [

        _sPz.crt.steps[0] == 0 ?
        cr.c(icvI1zS10To.N, {
          key: -10,
          sPz: _sPz,
          pagez: $pagez,
        })
        : null,

        _sPz.crt.steps[0] == 1 ?
        cr.c(icvI1zS11Co1.N, {
          key: -20,
          sPz: _sPz,
          pagez: $pagez,
        })
        : null,

        _sPz.crt.steps[0] == 2 ?
        cr.c(icvI1zS11Co2.N, {
          key: -30,
          sPz: _sPz,
          pagez: $pagez,
/*
          cz: {
            i18r_fst: $i18r_fst,
          }
*/
        })
        : null,

        _sPz.crt.steps[0] == 3 ?
        cr.c(icvI1zS11Co3.N, {
          key: -30,
          sPz: _sPz,
          pagez: $pagez,
        })
        : null,

      ]
    })
  );
};
